import React from "react";
import { useHistory } from "react-router-dom";

const NotFound = () => {
    const history = useHistory();
    return (
        <div>
            <h3 className="text-center">Sorry, 404 not found</h3>
            <button className="btn btn-primary w-75" onClick={history.push("/")}></button>
        </div>
    );
};

export default NotFound;
